import React, { useEffect, useState, useRef } from "react";
import {
    Container,
    Row,
    Col,
    Form,
    Button,
    InputGroup,
    Table,
    Pagination,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import swal from "sweetalert";
import {
    getTicketsCount,
    searchTicketsByQuery,
    updateTicket,
} from "../../Service/AllTicketServiceAPI";
import { Link } from "react-router-dom";
import SlaOpenTicketList from "./SlaTicketComp/SlaOpenTicketList";
import NonSlaOpenTicketList from "./NonSlaTicketComp/NonSlaOpenTicketList";
import SlaCloseTicketList from "./SlaTicketComp/SlaCloseTicketList";
import SlaTotalTicketList from "./SlaTicketComp/SlaTotalTicketList";
import SlaInprogressTicketList from "./SlaTicketComp/SlaInprogressTicketList";
import NonSlaCloseTicketList from "./NonSlaTicketComp/NonSlaCloseTicketList";
import NonSlaInprogressTicketList from "./NonSlaTicketComp/NonSlaInprogressTicketList";
import NonSlaTotalTicketList from "./NonSlaTicketComp/NonSlaTotalTicketList";
import moment from "moment";

const ITEMS_PER_PAGE = 5;

const TicketServiceNonTech = () => {
    const [ticketData, setTicketData] = useState(null);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeBox, setActiveBox] = useState("");
    const tableSectionRef = useRef(null);

    const handleBack = () => {
        setActiveBox("");
        setSearchTerm("");
        setSearchResults([]);
        setCurrentPage(1);
        fetchTicketData();
    };

    useEffect(() => {
        fetchTicketData();
    }, []);

    const fetchTicketData = async () => {
        try {
            const res = await getTicketsCount();
            setTicketData(res.data);
        } catch (err) {
            console.error("Ticket count fetch failed:", err);
        }
    };

    const handleSearch = async () => {
        const trimmed = searchTerm.trim();
        if (!trimmed) return;
        try {
            const res = await searchTicketsByQuery(trimmed);
            const data = (res.data || []).map(ticket => ({ ...ticket, isEditing: false }));
            setSearchResults(data);
            setCurrentPage(1);
        } catch (err) {
            console.error("Search failed:", err);
        }
    };

    const handleClear = () => {
        setSearchTerm("");
        setSearchResults([]);
        setCurrentPage(1);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") handleSearch();
    };

    const handleEditToggle = (index) => {
        const updated = [...searchResults];
        updated[index].isEditing = !updated[index].isEditing;
        setSearchResults(updated);
    };

    const handleInputChange = (index, field, value) => {
        const updated = [...searchResults];
        updated[index][field] = value;
        setSearchResults(updated);
    };

    const tableTitleMap = {
        slaOpen: "Open SLA Tickets",
        slaClose: "Close SLA Tickets",
        slaInprogress: "In Progress SLA Tickets",
        slaTotal: "Total SLA Tickets",
        nonSlaOpen: "Open Non SLA Tickets",
        nonSlaClose: "Close Non SLA Tickets",
        nonSlaInprogress: "In Progress Non SLA Tickets",
        nonSlaTotal: "Total Non SLA Tickets",
    };

    useEffect(() => {
        if (activeBox && tableSectionRef.current) {
            tableSectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [activeBox]);

    const handleSave = async (ticket, index) => {
        try {
            await updateTicket(ticket.ticketNumber, ticket);
            const updated = [...searchResults];
            updated[index].isEditing = false;
            setSearchResults(updated);
            swal("Success", "Ticket updated successfully", "success");
        } catch (err) {
            console.error("Save failed:", err);
            swal("Failed", "Could not update ticket", "error");
        }
    };

    const safeText = (value) => (value ?? "N/A");
    const formatDate = (dateStr) => dateStr ? new Date(dateStr).toLocaleDateString() : "N/A";
    const totalPages = Math.ceil(searchResults.length / ITEMS_PER_PAGE);
    const paginatedResults = searchResults.slice((currentPage - 1) * ITEMS_PER_PAGE, currentPage * ITEMS_PER_PAGE);



    const renderBox = (count = 0, label, key) => (
        <Col
            xs={6}
            sm={4}
            md={3}
            className="text-center mb-3"
            onClick={() => setActiveBox(prev => (prev === key ? "" : key))}
        >
            <div
                style={{
                    border: "2px solid #0d6efd",
                    borderRadius: "10px",
                    padding: "20px",
                    backgroundColor: activeBox === key ? "#cce5ff" : "#fff",
                    width: "70%",
                    height: "70px",
                    margin: "0 auto",
                    fontSize: "24px",
                    fontWeight: "bold",
                    textAlign: "center",
                    cursor: "pointer"
                }}
            >
                {count ?? 0}
            </div>
            <div
                style={{
                    marginTop: "5px",
                    fontSize: "16px",
                    textAlign: "center",
                    fontWeight: "bold"
                }}
            >
                {label}
            </div>
        </Col>
    );

    return (
        <Container fluid style={{ backgroundColor: "#e6e6e6", padding: "20px", minHeight: "100vh" }}>
            <Row className="mb-4 justify-content-center">
                <Col xs="auto" className="text-center">
                    <h3 style={{ background: "#488AC7", color: "#fff", padding: "4px 5px", borderRadius: "6px", boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)" }}>
                        Non-Tech Ticket Service
                    </h3>
                </Col>
            </Row>

            {!activeBox && (
                <>
                    <Row className="justify-content-center">
                        {renderBox(ticketData?.slaOpen, "Open SLA Tickets", "slaOpen")}
                        {renderBox(ticketData?.slaClose, "Close SLA Tickets", "slaClose")}
                        {renderBox(ticketData?.slaInprogress, "In Progress SLA", "slaInprogress")}
                        {renderBox(ticketData?.slaTotal, "Total SLA Tickets", "slaTotal")}
                    </Row>

                    <Row className="justify-content-center mt-4">
                        {renderBox(ticketData?.nonSlaOpen, "Open Non SLA", "nonSlaOpen")}
                        {renderBox(ticketData?.nonSlaClose, "Close Non SLA", "nonSlaClose")}
                        {renderBox(ticketData?.nonSlaInprogress, "In Progress Non SLA", "nonSlaInprogress")}
                        {renderBox(ticketData?.nonSlaTotal, "Total Non SLA", "nonSlaTotal")}
                    </Row>
                </>
            )}

            <Row className="mt-5 justify-content-center">
                <Col xs={12} md={5} className="mb-3">
                    <InputGroup>
                        <Form.Control
                            placeholder="Search by RO, Ticket No, Dispenser Sr. No..."
                            style={{ backgroundColor: "white", border: "2px solid black", fontWeight: "bold", fontSize: "14px", height: "40px" }}
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value.trimStart())}
                            onKeyDown={handleKeyDown}
                        />
                        <Button variant="dark" onClick={searchResults.length > 0 ? handleClear : handleSearch} style={{ height: "40px", fontSize: "14px" }}>
                            {searchResults.length > 0 ? "✖" : "🔍"}
                        </Button>
                    </InputGroup>
                </Col>
                <Col xs={6} md={2} className="text-start">
                    <Link to="RaiseTicketForm" className="btn btn-secondary">
                        + Raise Ticket
                    </Link>
                </Col>
            </Row>

            <div ref={tableSectionRef} className="mt-4">
                {activeBox ? (
                    <div className="mb-4">
                        <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">
                            <div>
                                <h5 className="mb-1">{tableTitleMap[activeBox] || "Ticket Details"}</h5>
                            </div>
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary d-flex align-items-center"
                                    onClick={handleBack}
                                >
                                    <FontAwesomeIcon icon={faArrowLeft} className="me-2" /> Back
                                </button>
                            </div>
                        </div>
                        <div style={{ border: "1px solid #cbd5e1", borderRadius: "12px", backgroundColor: "#ffffff", padding: "1rem" }}>
                            {activeBox === "slaOpen" && <SlaOpenTicketList />}
                            {activeBox === "slaClose" && <SlaCloseTicketList />}
                            {activeBox === "slaInprogress" && <SlaInprogressTicketList />}
                            {activeBox === "slaTotal" && <SlaTotalTicketList />}

                            {activeBox === "nonSlaOpen" && <NonSlaOpenTicketList />}
                            {activeBox === "nonSlaClose" && <NonSlaCloseTicketList />}
                            {activeBox === "nonSlaInprogress" && <NonSlaInprogressTicketList />}
                            {activeBox === "nonSlaTotal" && <NonSlaTotalTicketList />}
                        </div>
                    </div>
                ) : null}
            </div>




            {searchResults.length > 0 && (
                <Row className="mt-4">
                    <Col style={{ overflowX: "auto" }}>
                        <h6 className="mb-3 text-center">Searched Results Found</h6>
                        <Table bordered hover responsive striped size="sm" style={{ backgroundColor: "white" }}>
                            <thead style={{ backgroundColor: "#004417", color: "white" }}>
                                <tr>
                                    <th>No.</th>
                                    <th>Ticket No</th>
                                    <th>Job Type</th>
                                    <th>Type</th>
                                    <th>Action</th>
                                    <th>Status</th>
                                    <th>Dispenser Sr No</th>
                                    <th>Priority</th>
                                    <th>Issue Reported</th>
                                    <th>WO Status</th>
                                    <th>OMC Approval</th>
                                    <th>RO Name</th>
                                    <th>RO Address</th>
                                    <th>RO City</th>
                                    <th>RO State</th>
                                    <th>RO Country</th>
                                    <th>RO Contact</th>

                                    <th>Created</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedResults.map((ticket, index) => (
                                    <tr key={ticket.ticketId}>
                                        <td>{(currentPage - 1) * ITEMS_PER_PAGE + index + 1}</td>
                                        <td>{safeText(ticket.ticketNumber)}</td>
                                        {ticket.isEditing ? (
                                            <>
                                                <td><Form.Control value={ticket.jobType} onChange={(e) => handleInputChange(index, "jobType", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.ticketType} onChange={(e) => handleInputChange(index, "ticketType", e.target.value)} /></td>
                                                <td>
                                                    <Button variant="primary" size="sm" onClick={() => handleSave(ticket, index)}>Save</Button>{" "}
                                                    <Button variant="secondary" size="sm" onClick={() => handleEditToggle(index)}>Cancel</Button>
                                                </td>
                                                <td><Form.Control value={ticket.status} onChange={(e) => handleInputChange(index, "status", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.dispenserSrNo} onChange={(e) => handleInputChange(index, "dispenserSrNo", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.priority} onChange={(e) => handleInputChange(index, "priority", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.issueReported} onChange={(e) => handleInputChange(index, "issueReported", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.woStatus} onChange={(e) => handleInputChange(index, "woStatus", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.omcApprovalStatus} onChange={(e) => handleInputChange(index, "omcApprovalStatus", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roName} onChange={(e) => handleInputChange(index, "roName", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roAddress} onChange={(e) => handleInputChange(index, "roAddress", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roCity} onChange={(e) => handleInputChange(index, "roCity", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roState} onChange={(e) => handleInputChange(index, "roState", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roCountry} onChange={(e) => handleInputChange(index, "roCountry", e.target.value)} /></td>
                                                <td><Form.Control value={ticket.roContact} onChange={(e) => handleInputChange(index, "roContact", e.target.value)} /></td>

                                                <td>{formatDate(ticket.createdAt)}</td>

                                            </>
                                        ) : (
                                            <>
                                                <td>{safeText(ticket.jobType)}</td>
                                                <td>{safeText(ticket.ticketType)}</td>
                                                <td><Button size="sm" variant="success" onClick={() => handleEditToggle(index)}>Update</Button></td>
                                                <td>{safeText(ticket.status)}</td>
                                                     <td>{safeText(ticket.dispenserSrNo)}</td>
                                                <td>{safeText(ticket.priority)}</td>
                                                <td>{safeText(ticket.issueReported)}</td>
                                                <td>{safeText(ticket.woStatus)}</td>
                                                <td>{safeText(ticket.omcApprovalStatus)}</td>
                                                <td>{safeText(ticket.roName)}</td>
                                                <td>{safeText(ticket.roAddress)}</td>
                                                <td>{safeText(ticket.roCity)}</td>
                                                <td>{safeText(ticket.roState)}</td>
                                                <td>{safeText(ticket.roCountry)}</td>
                                                <td>{safeText(ticket.roContact)}</td>
                                           
                                                <td>{moment(ticket.createdAt).format("DD MMM YYYY, h:mm A")}</td>
                                                {/* <td>{moment(ticket.updatedAt).format("DD MMM YYYY, h:mm A")}</td> */}
                                            </>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <Pagination className="justify-content-center mt-3">
                            {[...Array(totalPages)].map((_, i) => (
                                <Pagination.Item
                                    key={i + 1}
                                    active={i + 1 === currentPage}
                                    onClick={() => setCurrentPage(i + 1)}
                                >
                                    {i + 1}
                                </Pagination.Item>
                            ))}
                        </Pagination>
                    </Col>
                </Row>
            )}
        </Container>
    );
};

export default TicketServiceNonTech;







